var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66338 15.471H3.24222V7.67418H5.66338V15.471ZM4.45149 6.61062C3.67729 6.61062 3.04932 5.96935 3.04932 5.19515C3.04932 4.42074 3.67709 3.79297 4.45149 3.79297C5.22589 3.79297 5.85367 4.42074 5.85367 5.19515C5.85367 5.96935 5.22544 6.61062 4.45149 6.61062ZM14.725 15.471H12.3091V11.6756C12.3091 10.771 12.2908 9.611 11.0502 9.611C9.79144 9.611 9.59854 10.5937 9.59854 11.6104V15.471H7.17999V7.67418H9.50209V8.73773H9.53598C9.85922 8.12515 10.6488 7.47867 11.8268 7.47867C14.2772 7.47867 14.7276 9.09225 14.7276 11.1881V15.471H14.725Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-Icon.4811bcf795578e874a0afa11751bfe90.svg";
export { ForwardRef as ReactComponent };